import { SubscriptionInvoice } from "../interfaces/subscriptionInvoice";
import { fetchWithAuth } from "./fetchWithAuth";

const PROD_APP_URL = process.env.REACT_APP_PROD_APP_URL || "";
const API_URL = process.env.REACT_APP_API_URL || "";
const DEV_API_URL = process.env.REACT_APP_DEV_API_URL || "";
const PROD_API_URL = process.env.REACT_APP_PROD_API_URL || "";

const apiBaseUrl =
  window.location.hostname === "localhost"
    ? API_URL
    : window.location.hostname === new URL(PROD_APP_URL).hostname
      ? PROD_API_URL
      : DEV_API_URL;

export const getSubscriptionInvoicesByDetail = async (
  subscriptionDetailID: number,
): Promise<SubscriptionInvoice[]> => {
  if (!apiBaseUrl) {
    throw new Error("API URL is not defined");
  }

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("User is not authenticated");
  }

  const response = await fetchWithAuth(
    `${apiBaseUrl}/api/SubscriptionInvoice/GetSubscriptionInvoicesByDetail/${subscriptionDetailID}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    const errorText = await response.text();
    console.error("Subscription Invoices Fetch Error:", errorText);
    throw new Error("Failed to fetch subscription invoices");
  }

  const subscriptionInvoices: SubscriptionInvoice[] = await response.json();
  return subscriptionInvoices;
};
